import React from 'react';

import {connect} from "react-redux";
import SelectCurrencies from "./fields/SelectCurrencies";
import * as utils from "../../utils/client";
import l10n from "../../l10n/localization";
import * as clientActions from "../../actions/client";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/client';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";

class ClientForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: this.props.item,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.client.name
                    },
                    email: {
                        type: "string",
                        title: l10n.client.email,
                    },
                    address: {
                        type: "string",
                        title: l10n.client.address
                    },
                    gitCode: {
                        type: "string",
                        title: l10n.client.gitCode
                    },
                    phone: {
                        type: "string",
                        title: l10n.client.phone
                    },
                    fax: {
                        type: "string",
                        title: l10n.client.fax
                    },
                    vatRate: {
                        type: "number",
                        title: l10n.client.vatRate,
                    },
                    comments: {
                        type: "string",
                        title: l10n.client.comments
                    },
                    currency: {
                        type: "string",
                        title: l10n.client.currency,
                        depth: this.props.depth,
                        openDrawer: this.props.openDrawer
                    }
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                address: {
                    "ui:widget": "textarea",
                    "ui:options": {
                        rows: 10
                    },
                    "ui:emptyValue": ""
                },
                comments: {
                    "ui:widget": "textarea",
                    "ui:options": {
                        rows: 10
                    },
                    "ui:emptyValue": ""
                },
                currency: {
                    "ui:field": "selectCurrencies",
                },
                gitCode: {
                    "ui:emptyValue": ""
                },
                phone: {
                    "ui:emptyValue": ""
                },
                fax: {
                    "ui:emptyValue": ""
                },
                email: {
                    "ui:emptyValue": ""
                },
                vatRate: {
                    "ui:emptyValue": "",
                },
            },
            fields: {
                selectCurrencies: SelectCurrencies
            },
            formData: utils.clientToForm(this.props.item),
            isDirty: false
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(clientActions.edit(form));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(clientActions.edit(form));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                this.props.dispatch(clientActions.add(form, utilsCommon.notNullNorUndefined(this.props.item) ? this.props.item.selectNewItem : false));
            })
        }
        this.setState((state) => {return {...state, isDirty: false,formData: formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleError = () => {
        this.props.dispatch(clientActions.errorMessage(l10n.validation.form_error));
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    render() {

        if (this.props.loading) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'client-form dirty':'client-form';

        return (
            <div className={formClassName}>
                {this.props.title !== undefined && <h1>{this.props.title}</h1>}
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    onSubmit={this.onSubmit}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    onError={this.handleError}
                    fields={this.state.fields} >
                        <div>
                            <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                        </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        saving: state.client.saving,

        newlyCreatedElement: state.creation.newlyCreatedClient,
    });
})(ClientForm);


// WEBPACK FOOTER //
// ./src/components/forms/ClientForm.js